export default __webpack_public_path__ + "static/media/super market 2.36f87fc8.jpg";